import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {  fetchOurPeople } from '../../api'; // Import from api.js


// Async thunk for fetching dashboard data
export const fetchOurPeopleData = createAsyncThunk(
  'ourPeople',
  async (_, { rejectWithValue }) => {
    try {
      // Use the function from api.js
      const data = await fetchOurPeople();
      return data;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch dashboard data');
    }
  }
);

const ourPeopleSlice = createSlice({
  name: 'ourPeople',
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {
    resetError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOurPeopleData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOurPeopleData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchOurPeopleData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetError } = ourPeopleSlice.actions;
export default ourPeopleSlice.reducer;
